import { PORTAL_NAME_MODAL_DEFINE } from 'components/common/PortalModal/config';
import { FUNC_DEFAULT, OBJECT_DEFAULT } from 'constants';
import {
  PAYTO_ACCOUNT_ACTIVE_STATUS,
  PAYTO_ACCOUNT_AMEND_COMPLETED_STATUS,
  PAYTO_ACCOUNT_CANCELLED_STATUS,
  PAYTO_ACCOUNT_CREATED_STATUS,
  PAYTO_ACCOUNT_INPROGRESS_STATUS,
  PAYTO_LOG_TAG,
} from 'features/to/const';
import usePayto from 'features/to/hooks/payment/usePayto';
import usePaytoAPI from 'features/to/hooks/payment/usePaytoAPI';
import usePaytoStore from 'features/to/hooks/payment/usePaytoStore';
import useCommonStore from 'hooks/useCommonStore';
import usePortalModal from 'hooks/usePortalModal';
import { delay, isEmpty } from 'lodash';
import React from 'react';
import withAddPaytoAccountsAgreement from './withAddPaytoAccountsAgreement';
import withEditPaytoAccountAgreements from './withEditPaytoAccountAgreements';

const withPaytoAgreementProcessing = (Component) => {
  const AddPaytoAgreementProcessingComponent = withAddPaytoAccountsAgreement(
    withEditPaytoAccountAgreements((props) => {
      const {
        fetchPaytoAccountsAgreementLatest,
        onSelect: paytoAccountAgreementOnSelect,
        onSelectValid: paytoAccountAgreementOnSelectValid,
        onEdit,
        isAddManual,
        onSelect,
      } = props || {};

      const { setLoading } = useCommonStore();
      const {
        addPaytoAccountAgreement,
        updatePaytoAccountAgreementById,
        checkStatusPaytoAccountAgreementById,
        payloadTransformFromPaytoAccountAgreement,
      } = usePaytoAPI();
      const { showPortalModalName, closePortalModalName } = usePortalModal();
      const {
        paytoAccountAuthorising,
        paytoAccountInformation,
        setPaytoAccountInformation,
        setPaytoAccountAuthorising,
        isAccountAgreementEditing,
        paytoBankAccountsVerified,
      } = usePaytoStore();
      const { onShowAddPaytoAccountModal } = usePayto();

      const handlePaytoAccountAgreementOnSelect = (
        accountAgreement = OBJECT_DEFAULT
      ) => {
        const { paymentAgreementUID, payId } = accountAgreement || {};
        console.log(
          `⭐ withPaytoAgreementProcessing 👉 handlePaytoAccountAgreementOnSelect ↩`
        );
        fetchPaytoAccountsAgreementLatest((data) => {
          if (isEmpty(data)) return;
          const currentAccountAgreementSelected = data?.find(
            (d) => d?.paymentAgreementUID === paymentAgreementUID
          );
          if (currentAccountAgreementSelected) {
            paytoAccountAgreementOnSelect(currentAccountAgreementSelected);
            return;
          }
          paytoAccountAgreementOnSelectValid(data);
        });
      };

      const onShowPaytoAccountAuthoriseProcessingTimeoutModal = (
        isEdit = false
      ) => {
        showPortalModalName({
          name: PORTAL_NAME_MODAL_DEFINE.AUTHORISE_PAYTO_ACCOUNT_TIMEOUT_MODAL,
          modalOptions: {
            isEdit,
          },
        });
      };

      const onPaytoAccountAuthoriseProcessingTimeout = (isEdit = false) => {
        console.log(
          `⭐ ${PAYTO_LOG_TAG} 👉 onPaytoAccountAuthoriseProcessingTimeout ➡️ START ↩`
        );
        closePortalModalName();
        onShowPaytoAccountAuthoriseProcessingTimeoutModal(isEdit);
      };

      const onPaytoAccountAuthoriseCheckStatus = async (
        countdownCallback = FUNC_DEFAULT,
        isEdit = false
      ) => {
        try {
          if (isEmpty(paytoAccountAuthorising)) {
            console.error(
              `🔥 ${PAYTO_LOG_TAG} ❌ onPaytoAccountAuthoriseCheckStatus ➡️ paytoAccountAuthorising is empty ↩`
            );
            countdownCallback?.(true);
            return;
          }

          checkStatusPaytoAccountAgreementById(
            paytoAccountAuthorising,
            (data) => {
              const { paymentAgreementStatus, pendingAmend, amendmentStatus } =
                data || {};
              if (
                paymentAgreementStatus === PAYTO_ACCOUNT_CREATED_STATUS ||
                paymentAgreementStatus === PAYTO_ACCOUNT_INPROGRESS_STATUS
              ) {
                countdownCallback?.();
                return;
              }

              if (
                isAccountAgreementEditing &&
                paymentAgreementStatus === PAYTO_ACCOUNT_ACTIVE_STATUS &&
                !pendingAmend
              ) {
                if (amendmentStatus === PAYTO_ACCOUNT_AMEND_COMPLETED_STATUS) {
                  closePortalModalName();
                  setLoading(true);
                  countdownCallback?.(true);
                  delay(
                    (accountAgreement) => {
                      setLoading(false);
                      showPortalModalName({
                        name: PORTAL_NAME_MODAL_DEFINE.UPDATE_PAYTO_ACCOUNT_SUCCESS_MODAL,
                        action: () =>
                          handlePaytoAccountAgreementOnSelect(accountAgreement),
                      });
                    },
                    600,
                    paytoAccountAuthorising
                  );
                  return;
                }
                if (amendmentStatus !== PAYTO_ACCOUNT_AMEND_COMPLETED_STATUS) {
                  closePortalModalName();
                  setLoading(true);
                  countdownCallback?.(true);
                  delay(
                    (accountAgreement) => {
                      setLoading(false);
                      showPortalModalName({
                        name: PORTAL_NAME_MODAL_DEFINE.AUTHORISE_PAYTO_ACCOUNT_REJECT_MODAL,
                        action: () => {
                          console.log(
                            `⭐ ${PAYTO_LOG_TAG} 👉 onPaytoAccountAuthoriseCheckStatus ➡️ amendmentStatus ➡️ EDIT ↩`,
                            accountAgreement
                          );
                          onEdit(accountAgreement);
                        },
                        actionClose: () => {
                          closePortalModalName();
                        },
                        modalOptions: {
                          isEdit: true,
                        },
                      });
                    },
                    1000,
                    paytoAccountAuthorising
                  );
                }
                return;
              }

              if (
                !isAccountAgreementEditing &&
                paymentAgreementStatus === PAYTO_ACCOUNT_ACTIVE_STATUS &&
                !pendingAmend
              ) {
                closePortalModalName();
                setLoading(true);
                countdownCallback?.(true);
                delay(
                  (accountAgreement) => {
                    setLoading(false);
                    showPortalModalName({
                      name: PORTAL_NAME_MODAL_DEFINE.AUTHORISE_PAYTO_ACCOUNT_SUCCESS_MODAL,
                      action: () =>
                        handlePaytoAccountAgreementOnSelect(accountAgreement),
                    });
                  },
                  600,
                  paytoAccountAuthorising
                );
                return;
              }

              if (paymentAgreementStatus === PAYTO_ACCOUNT_ACTIVE_STATUS) {
                countdownCallback?.();
                return;
              }

              closePortalModalName();
              setLoading(true);
              countdownCallback?.(true);
              delay(
                (accountAgreement) => {
                  setLoading(false);
                  showPortalModalName({
                    name: PORTAL_NAME_MODAL_DEFINE.AUTHORISE_PAYTO_ACCOUNT_REJECT_MODAL,
                    action: () => {
                      if (isAccountAgreementEditing) {
                        console.log(
                          `⭐ ${PAYTO_LOG_TAG} 👉 onPaytoAccountAuthoriseCheckStatus ➡️ isAccountAgreementEditing ➡️ CANCELLED ↩`,
                          accountAgreement
                        );
                        if (
                          paymentAgreementStatus ===
                          PAYTO_ACCOUNT_CANCELLED_STATUS
                        ) {
                          fetchPaytoAccountsAgreementLatest(() => {
                            setLoading(false);
                            onSelect();
                          });
                          closePortalModalName();
                        } else if (
                          paymentAgreementStatus === PAYTO_ACCOUNT_ACTIVE_STATUS
                        ) {
                          onEdit(accountAgreement);
                        } else {
                          closePortalModalName();
                        }
                      } else {
                        console.log(
                          `⭐ ${PAYTO_LOG_TAG} 👉 onPaytoAccountAuthoriseCheckStatus ➡️ onShowAddPaytoAccountModal ↩`,
                          accountAgreement
                        );
                        onShowAddPaytoAccountModal({
                          // paytoAccountInformationRetry: paytoAccountInformation,
                          paytoAccountInformationRetry: null,
                        });
                      }
                    },
                    actionClose: () => {
                      closePortalModalName();
                    },
                    modalOptions: {
                      isEdit,
                    },
                  });
                },
                1000,
                paytoAccountAuthorising
              );
            },
            (errorData) => {
              console.error(
                `🔥 ${PAYTO_LOG_TAG} ❌ onPaytoAccountAuthoriseCheckStatus ➡️ errorData ↩`,
                errorData
              );
              countdownCallback?.(true);
              if (!isEmpty(errorData)) {
                delay(
                  () =>
                    showPortalModalName({
                      name: PORTAL_NAME_MODAL_DEFINE.AUTHORISE_PAYTO_ACCOUNT_REJECT_MODAL,
                      modalData: errorData,
                      action: () => {
                        fetchPaytoAccountsAgreementLatest(() => {
                          setLoading(false);
                          onSelect();
                        });
                        closePortalModalName();
                      },
                      actionClose: () => {
                        fetchPaytoAccountsAgreementLatest(() => {
                          setLoading(false);
                          onSelect();
                        });
                        closePortalModalName();
                      },
                      modalOptions: {
                        isEdit,
                      },
                    }),
                  1000,
                  null
                );
              }
            }
          );
        } catch (error) {
          console.error(
            `🔥 ${PAYTO_LOG_TAG} ❌ onPaytoAccountAuthoriseCheckStatus ↩`,
            error?.message
          );
          setLoading(false);
          countdownCallback?.(true);
        }
      };

      const onAddPaytoAccountAuthorise = async (
        callback = FUNC_DEFAULT,
        errorCallback = FUNC_DEFAULT
      ) => {
        try {
          if (isEmpty(paytoAccountInformation)) {
            console.error(
              `🔥 ${PAYTO_LOG_TAG} ❌ onAddPaytoAccountAuthorise ➡️ paytoAccountInformation is empty ↩`
            );
            return;
          }

          setLoading(true);
          addPaytoAccountAgreement(
            paytoAccountInformation,
            (accountAgreement) => {
              setPaytoAccountAuthorising(accountAgreement);
              callback();
              setLoading(false);
            },
            (errorData) => {
              setLoading(false);
              errorCallback?.(errorData);
            }
          );
        } catch (error) {
          setLoading(false);
          console.error(
            `🔥 ${PAYTO_LOG_TAG} ❌ onAddPaytoAccountAuthorise ↩`,
            error?.message
          );
        }
      };

      const onUpdatePaytoAccountAuthorise = async (
        accountAgreement = OBJECT_DEFAULT,
        callback = FUNC_DEFAULT,
        errorCallback = FUNC_DEFAULT
      ) => {
        try {
          if (isEmpty(accountAgreement)) {
            console.error(
              `🔥 ${PAYTO_LOG_TAG} ❌ onUpdatePaytoAccountAuthorise ➡️ accountAgreement is empty ↩`
            );
            return;
          }

          setLoading(true);
          updatePaytoAccountAgreementById(
            accountAgreement,
            (accountAgreement) => {
              setPaytoAccountAuthorising(accountAgreement);
              callback();
              setLoading(false);
            },
            (errorData) => {
              setLoading(false);
              errorCallback?.(errorData);
            }
          );
        } catch (error) {
          setLoading(false);
          console.error(
            `🔥 ${PAYTO_LOG_TAG} ❌ onUpdatePaytoAccountAuthorise ↩`,
            error?.message
          );
        }
      };

      const newProps = {
        ...props,
        onPaytoAccountAuthoriseProcessingTimeout,
        onPaytoAccountAuthoriseCheckStatus,
        onAddPaytoAccountAuthorise,
        onUpdatePaytoAccountAuthorise,
      };
      return <Component {...newProps} />;
    })
  );
  return AddPaytoAgreementProcessingComponent;
};

export default withPaytoAgreementProcessing;
